module.exports = __webpack_public_path__ + "img/Support-skill-225.48350d4b.png";